import { headingSizeProp, headingTagProp, wysiwygProp } from 'utils/proptypes/modules/textProps';

import AnimationWrapper from 'components/wrappers/AnimationWrapper';
import Heading from 'components/text/Heading';
import NewsletterForm from 'components/Newsletter';
import Paragraph from 'components/text/Paragraph';
import PropTypes from 'prop-types';
import React from 'react';
import { TextLinkWysisyg } from 'components/text/TextLink';
import Wysiwyg from 'libs/wordpress/components/Wysiwyg';
import styled from 'libs/styled';
import { toCamelCase } from 'utils/string';

const Wrapper = styled('div')`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
`;

const Content = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 100%;
`;

const FormWrapper = styled(AnimationWrapper)`
    margin-top: 48px;
`;

/**
 * Display a newsletter signup field
 *
 * @param {object} form - An object that contains all form settings and data.
 * @param {string} formTheme - Theme for form color settings.
 * @param {string} heading - Heading as a string.
 * @param {string} headingSize - Determines the size of the heading.
 * @param {string} headingTag - The html-tag used by heading; h1, h2, h3 etc.
 * @param {array} text - wysiwyg displayes above the form.
 * @param {string} textColor - Color for all text in hex format.
 */

const Newsletter = ({ form, formTheme = '', heading, headingSize, headingTag, text, textColor = '' }) => (
    <Wrapper color={textColor}>
        <Heading withAnimation as={headingTag} size={headingSize}>
            {heading}
        </Heading>
        <Content marginTop={['80px', null, '0']}>
            <AnimationWrapper>
                <Wysiwyg
                    data={text}
                    tagComponents={{ url: TextLinkWysisyg }}
                    textComponent={props => <Paragraph size="lg" {...props} />}
                />
            </AnimationWrapper>
            <FormWrapper>
                <NewsletterForm
                    id={heading ? toCamelCase(heading) : 'newsletter-content-blocks'}
                    theme={formTheme}
                    {...form}
                />
            </FormWrapper>
        </Content>
    </Wrapper>
);

Newsletter.propTypes = {
    form: PropTypes.object,
    formTheme: PropTypes.string,
    fullWidth: PropTypes.bool,
    heading: PropTypes.string,
    headingSize: headingSizeProp,
    headingTag: headingTagProp,
    text: wysiwygProp,
    textColor: PropTypes.string,
};

export default Newsletter;
